import React, { useContext } from "react";
import { MainContext } from "../App";
import CloseIcon from "../icons/CloseIcon";

export default function QrPopup() {
	const {
		tempTable,
		setQrPopupVisible,
		ordersDisabled,
		initCart,
		cart,
		setFlow,
		setTable,
		setTableEditPopup,
		setQrPopupCloseToTables,
		closeQrPopup,
	} = useContext(MainContext);

	const handleNewOrder = () => {
		setQrPopupCloseToTables(false);
		if (!cart?.products?.length) {
			initCart();
		}
		setFlow(1);
		setTable(tempTable);
		setTableEditPopup(false);
		setQrPopupVisible(false);
	};

	return (
		<div className="popup md qr-popup">
			<div className="container qr-popup-container">
				<header>
					<div className="buttons-group qr-header-actions">
						<button
							className="btn btn-tertiary btn-square"
							onClick={closeQrPopup}
						>
							<CloseIcon />
						</button>
					</div>
				</header>
				<div className="content qr-code-container">
					<div className="qr-table-meta">
						<div className="qr-table-name">{tempTable.name}</div>
						<div className="qr-table-room">{tempTable.room?.name || ""}</div>
					</div>
					<div className="pin">
						<div className="pin-label">PIN</div>
						<div className="pin-value">{tempTable.pin}</div>
					</div>
					<a
						className="qr-frame qr-frame-link"
						href={tempTable.url}
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							src={
								"https://api.yellgo.cloud/class/barcode.php?f=png&s=qr&w=500&h=500&d=" +
								encodeURIComponent(tempTable.url)
							}
						/>
					</a>
					{!ordersDisabled && (
						<button
							type="button"
							className="btn btn-primary btn-block table-action-full table-action-new-order"
							onClick={handleNewOrder}
						>
							Nuova comanda
						</button>
					)}
				</div>
			</div>
		</div>
	);
}
